/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Reducedtemperatureabs2Inputs */



/**
* | output |
* | --- |
* | "Absolute reduced temperature" |
*
* @param {Br_History_Key_Reducedtemperatureabs2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_reducedtemperatureabs2 = /** @type {((inputs?: Br_History_Key_Reducedtemperatureabs2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Reducedtemperatureabs2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Absolute reduced temperature")
	return /** @type {LocalizedString} */ ("Température réduite absolue")
});
export { br_history_key_reducedtemperatureabs2 as "br_history_key_reducedTemperatureAbs" }